<table class="compare">
  <thead>
  <tr>
    <td></td>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <th [class.active]="config === currentConfigurationType">
        {{ textkeyPrefix + '.anlage.label.' + config.replace(OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG, '') | translate }}
        <small [innerHTML]="textkeyPrefixCompare + config.replace(OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG, '') + '.description' | translate"></small>
      </th>
    }
  </tr>
  </thead>
  <tbody>
  <tr class="highlight">
    <th [innerHTML]="textkeyPrefixCompare + 'gesamtleistung' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['leistung_gesamt'] }}
        <small [innerHTML]="'unit.kwp' | translate"></small>
        ({{ result.result.placeholder[config]['flaeche_gesamt'] }}&nbsp;<small [innerHTML]="'unit.m2' | translate"></small>)
      </td>
    }
  </tr>
  <tr>
    <th [innerHTML]="textkeyPrefixCompare + 'batteriespeicher' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['batteriespeicher_kapazitaet']?? '-' }}
        <small [innerHTML]="'unit.kwh' | translate"></small>
      </td>
    }
  </tr>
  <tr class="highlight">
    <th [innerHTML]="textkeyPrefixCompare + 'eigennutzung.anteil' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['leistung']?? '-' }}
        <small [innerHTML]="'unit.kwp' | translate"></small>
        ({{ result.result.placeholder[config]['flaeche']?? '-' }}&nbsp;<small [innerHTML]="'unit.m2' | translate"></small>)
      </td>
    }
  </tr>
  <tr>
    <th [innerHTML]="textkeyPrefixCompare + 'eigennutzung.strom' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['eigennutzung']?? '-' }}
        <small [innerHTML]="'unit.kwha' | translate"></small>
      </td>
    }
  </tr>
  <tr>
    <th [innerHTML]="textkeyPrefixCompare + 'batteriespeicher.verlust' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['batteriespeicher_verluste']?? '-' }}
        <small [innerHTML]="'unit.kwha' | translate"></small>
      </td>
    }
  </tr>
  <tr>
    <th [innerHTML]="textkeyPrefixCompare + 'ueberschusseinspeisung' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['einspeisung']?? '-' }}
        <small [innerHTML]="'unit.kwha' | translate"></small>
      </td>
    }
  </tr>
  <tr>
    <th [innerHTML]="textkeyPrefixCompare + 'stromzukauf' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['stromzukauf']?? '-' }}
        <small [innerHTML]="'unit.kwha' | translate"></small>
      </td>
    }
  </tr>
  <tr class="highlight">
    <th [innerHTML]="textkeyPrefixCompare + 'volleinspeisung.anteil' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['leistung_volleinspeisung_plain'] > 0? result.result.placeholder[config]['leistung_volleinspeisung'] :  '-' }}
        <small [innerHTML]="'unit.kwp' | translate"></small>
        ({{ result.result.placeholder[config]['flaeche_volleinspeisung_plain'] > 0? result.result.placeholder[config]['flaeche_volleinspeisung'] :  '-' }}&nbsp;<small [innerHTML]="'unit.m2' | translate"></small>)
      </td>
    }
  </tr>
  <tr>
    <th [innerHTML]="textkeyPrefixCompare + 'netzeinspeisung' | translate"></th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        @if(result.result.placeholder[config]['ertrag_volleinspeisung_plain'] > 0) {
          {{ result.result.placeholder[config]['ertrag_volleinspeisung'] }}
        }
        @else {
          -
        }
        <small [innerHTML]="'unit.kwha' | translate"></small>
      </td>
    }
  </tr>
  <tr class="divider">
    <td [attr.colspan]="configurationTypes.length + 1"></td>
  </tr>
  <tr class="costs">
    <th [class.clickable]="showInvestToggle" (keydown.enter)="showInvestToggle? toggleInfo('invest') : null" (click)="showInvestToggle? toggleInfo('invest') : null">
      {{ textkeyPrefixCompare + 'investitionen' | translate }}
      @if(this.showInvestToggle) {
        <button [tabindex]="isHidden? '-1' : '0'" class="chevron" [attr.aria-expanded]="toggle.invest" [attr.aria-controls]="'invest' + (hasCredit? ' credit' : '') + (hasEquity? ' equity' : '') " [title]="textkeyPrefix + '.details' | translate" role="button" (keydown.enter)="toggleInfo('invest')"><i class="icon-chevron-down" [class.rotate]="toggle.invest"></i></button>
      }
    </th>
    @for(config of configurationTypes; track config) {
      <td>
        {{ systems[config].finanzierung.investitionskosten_gesamt | number: '1.0-0' }}
        <small>€</small>
      </td>
    }
  </tr>
  @if (toggle.invest) {
    <tr id="invest">
      <th [innerHTML]="textkeyPrefixCompare + 'zuschuss' | translate"></th>
      @for(config of configurationTypes; track result.result.placeholder[config]) {
        <td>
          @if(systems[config].finanzierung?.foerderung_zuschuss?.summe > 0) {
            {{ systems[config].finanzierung.foerderung_zuschuss.summe | number: '1.0-0' }}
          } @else {
            -
          }
          <small>€</small>
        </td>
      }
    </tr>
    @if (hasCredit) {
      <tr id="credit">
        <th [innerHTML]="textkeyPrefixCompare + 'kredit' | translate"></th>
        @for(config of configurationTypes; track result.result.placeholder[config]) {
          <td>
            @if(systems[config].finanzierung?.foerderung_kredit?.summe > 0) {
              {{ systems[config].finanzierung.foerderung_kredit.summe | number: '1.0-0' }}
            } @else {
              -
            }
            <small>€</small>
          </td>
        }
      </tr>
    }
    @if(hasEquity) {
      <tr id="equity">
        <th [innerHTML]="textkeyPrefixCompare + 'eigenkapital' | translate"></th>
        @for(config of configurationTypes; track result.result.placeholder[config]) {
          <td>
            @if (anfrage.userInput?.eigenkapital > 0) {
              {{ anfrage.userInput.eigenkapital | number: '1.0-0' }}
            } @else {
              -
            }
            <small>€</small>
          </td>
        }
      </tr>
    }
  }
  <tr class="costs">
    <th (keydown.enter)="toggleInfo('balance')" (click)="toggleInfo('balance')" class="clickable">
      <span>
        {{ textkeyPrefixCompare + 'bilanz' | translate }}<br>
        <small>{{ textkeyPrefixCompare + 'bilanz.laufzeit' | translate }}</small>
      </span>
      <button [tabindex]="isHidden? '-1' : '0'" class="chevron" [attr.aria-expanded]="toggle.balance" aria-controls="balance-costs balance-savings" [title]="textkeyPrefix + '.details' | translate" (keydown.enter)="toggleInfo('balance')"><i class="icon-chevron-down" [class.rotate]="toggle.balance"></i></button>
    </th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['kostenbilanz_laufzeit'] }}
        <small>€</small>
      </td>
    }
  </tr>
  @if (toggle.balance) {
    <tr id="balance-costs">
      <th [innerHTML]="textkeyPrefixCompare + 'kosten' | translate"></th>
      @for(config of configurationTypes; track result.result.placeholder[config]) {
        <td>
          {{ result.result.placeholder[config]['kosten_laufzeit'] }}
          <small>€</small>
        </td>
      }
    </tr>
    <tr id="balance-savings">
      <th [innerHTML]="textkeyPrefixCompare + 'einsparungen' | translate"></th>
      @for(config of configurationTypes; track result.result.placeholder[config]) {
        <td>
          {{ result.result.placeholder[config]['einsparungen_laufzeit'] }}
          <small>€</small>
        </td>
      }
    </tr>
  }
  <tr class="costs">
    <th class="clickable" (keydown.enter)="toggleInfo('balance20')" (click)="toggleInfo('balance20')">
      <span>
        {{ textkeyPrefixCompare + 'bilanz' | translate }}<br>
        <small>{{ textkeyPrefixCompare + 'bilanz.laufzeitende' | translate }}</small>
      </span>
      <button [tabindex]="isHidden? '-1' : '0'" class="chevron" [attr.aria-expanded]="toggle.balance20" aria-controls="balance20-costs balance20-savings" [title]="textkeyPrefix + '.details' | translate" (keydown.enter)="toggleInfo('balance20')"><i class="icon-chevron-down" [class.rotate]="toggle.balance20"></i></button>
    </th>
    @for(config of configurationTypes; track result.result.placeholder[config]) {
      <td>
        {{ result.result.placeholder[config]['kostenbilanz_laufzeitende'] }}
        <small>€</small>
      </td>
    }
  </tr>
  @if (toggle.balance20) {
    <tr id="balance20-costs">
      <th [innerHTML]="textkeyPrefixCompare + 'kosten' | translate"></th>
      @for(config of configurationTypes; track result.result.placeholder[config]) {
        <td>
          {{ result.result.placeholder[config]['kosten_laufzeitende'] }}
          <small>€</small>
        </td>
      }
    </tr>
    <tr id="balance20-savings">
      <th [innerHTML]="textkeyPrefixCompare + 'einsparungen' | translate"></th>
      @for(config of configurationTypes; track result.result.placeholder[config]) {
        <td>
          {{ result.result.placeholder[config]['einsparungen_laufzeitende'] }}
          <small>€</small>
        </td>
      }
    </tr>
  }
  </tbody>
</table>
